import React from 'react';
import SvgIcon from './SvgIcon';

const ArrowTaleUp = props => (
    <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
        <path
            d="M12.25 18.875v-13.5M17.5 10.375l-5.25-5.25L7 10.375"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

ArrowTaleUp.displayName = 'ArrowTaleUpIcon';

export default ArrowTaleUp;
